const getFullUrl = (section: string, slug?: string): string => {
  return `/${section}/${slug}`.toLowerCase();
};

export default getFullUrl;
